import React from 'react';
import { CssBaseline, ThemeProvider, createTheme } from '@mui/material';
import CoursesPage from './pages/CoursesPage';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import {CourseDetailPage} from './pages/CourseDetailPage';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import IconButton from '@mui/material/IconButton';
import PopupAd from './components/PopupAd.jsx';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import InstagramIcon from '@mui/icons-material/Instagram';
import DynamoDBAd from './components/DynamoDBAd.jsx';
import LinkedInIcon from '@mui/icons-material/LinkedIn';


const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#D32F2F', // Shade of red
    },
    background: {
      default: '#0B0F1A', // Dark blue almost black
      paper: '#121826',   // Slightly lighter for cards
    },
  },
  typography: {
    fontFamily: "'Poppins', sans-serif",
  },
});

const App = () => (
  <ThemeProvider theme={darkTheme}>
    <CssBaseline />
    <link
      href="https://fonts.googleapis.com/css2?family=Poppins:wght@400;600&display=swap"
      rel="stylesheet"
    />
     <Box
        sx={{
          
          
            backgroundColor: '#121826',
            color: '#fff',
            padding: '8px 16px',
            textAlign: 'center',
            width: '100%',
          
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
            fontFamily: "'Poppins', sans-serif",
            fontSize: '0.8rem',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        }}
    >
        <Typography
            variant="body2"
            sx={{
                marginRight: 2,
                textShadow: '0 0 2px rgba(255, 255, 255, 0.8)',
                fontWeight: 'bold',
            }}
        >
            Support us by following our LinkedIn page:
        </Typography>
        
        <Button
      variant="contained"
      sx={{
        backgroundColor: '#0A66C2', // LinkedIn blue
      }}
      startIcon={<LinkedInIcon />}
      onClick={() => window.open("https://www.linkedin.com/company/line51", "_blank")}
    >
      Line51
    </Button>


    </Box>
    {/* <PopupAd /> */}
    <Container maxWidth={false} sx={{ mt: 2, px: 4, display: 'flex', alignItems: {
        xs: 'flex-start',
        sm: 'center',
      }, justifyContent: 'space-between', flexDirection: { xs: 'column', sm: 'row' } }}>
        <Typography
          onClick={() => { window.location.href = "/"; }}
          sx={{ cursor: 'pointer' }}
          variant="h4"
          gutterBottom
          fontWeight="bold"
        >
          <span style={{ color: '#fff' }}>Line</span>
          <span style={{ color: '#f44336' }}>51</span>
        </Typography>
        <Box gap={2} sx={{ display: 'flex', alignItems: 'left',flexDirection : {'xs' : 'column','sm' : 'row'} }} >
          <Button
            variant="contained"
            sx={{
              background: 'orange',
              color: 'black',
              borderRadius: 1.5,
              fontWeight: 600,
              fontFamily: "'Poppins', sans-serif",
              mr: 2,
              boxShadow: 'none',
              '&:hover': {
                background: '#ff9800',
                boxShadow: 'none',
              },
            }}
            onClick={() => window.open('/exp/aws')}
          >
            Get AWS Courses!
          </Button>
          <Button
            variant="outlined"
            startIcon={<InstagramIcon />}
            sx={{
              color: '#fff',
              borderColor: '#fff',
              fontFamily: "'Poppins', sans-serif",
              fontWeight: 600,
              '&:hover': {
                backgroundColor: 'pink',
                color: 'black',
              },
            }}
            onClick={() => { window.location.href = "https://www.instagram.com/kona_pavan_kumar/"; }}
          >
            Connect Me
          </Button>
        </Box>
      </Container>

     {/* <DynamoDBAd /> */}
    <Router>
      <Routes>
        {/* if home, redirect to page=1 */}
        <Route path="/" element={<CoursesPage />} />
        <Route path="/exp/:exp" element={<CoursesPage />} />
        <Route path="/courses/:slug" element={<CourseDetailPage />} />
        <Route path="/:category/:page" element={<CoursesPage />} />
      </Routes>
    </Router>
  </ThemeProvider>
);

export default App;
